<template>
    <div class="footer" v-if="footerData">
        <div class="pc_footer">
            <div class="footer-con">
                <div class="foot-menus">
                    <div class="left-cont">
                        <div class="li" v-for="(item,idx) in footerData.menus" :key="idx" v-if="item.status == 0" > 
                                <a :href="item.url" class="mheader" v-if="item.url">{{ item.title }}</a>
                                <a  class="mheader" v-else>{{ item.title }}</a>
                                <!-- <a class="link" :href="el.href" v-for="el in item.children">{{el.title}}</a> -->
                                <template v-if="item.children">
                                    <div class="link son_li_skip" :class="{white:item.title=='联系我们'}"  @click="tiaozhuan(el)" v-for="el in item.children" >{{ el.title }}</div>
                                </template> 
                        </div>
                    </div>
                    <div class="right-cont">
                        <div class="li border-li">
                            <a class="mheader " href="./index.php?s=index/join&nav=2#nav" >联系地址</a>
                            <div class="link">地址：{{ footerData.linkInfo.address }}</div>
                            <div class="link">电话：{{ footerData.linkInfo.tel }}</div>
                            <div class="link">邮箱：{{ footerData.linkInfo.email }}</div>
                        </div>
                        <div class="li">
                            <div class="mheader bd-header">关注互动派</div>
                            <div class="qrcode">
                                <div class="item">
                                    <div class="img">
                                        <img class="img" :src="footerData.linkInfo.qrcodeList[0].image" alt="">
                                    </div>
                                    <div class="text">微信公众号</div>
                                </div>
                                <div class="item">
                                    <div class="img">
                                        <img class="img" :src="footerData.linkInfo.qrcodeList[1].image" alt="">
                                    </div>
                                    <div class="text">微信视频号</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="copyright" v-html="footerData.copyright">

            </div>
        </div>
        <div class="wap_footer">
            <ul class="menu_ul">
                <li class="menu_li" v-for="(item, index) in footerData.menus" @click.stop="openMenu(item, index)" :data-index="index">
                    <div class="menu_li_span no_children" @click.stop="openMenu(item, index)" :data-index="index">
                        <a :href="item.url" class="txt" v-if="item.url">{{ item.title }}</a>
                        <a  class="txt" v-else >{{ item.title }}</a>

                        <div class="icon_open" v-if="item.isOpen" @click.stop="openMenu(item, index)" :data-index="index"></div>
                        <div class="icon_close" v-else @click.stop="openMenu(item, index)" :data-index="index"></div>
                    </div>

                    <ul class="son" v-if="item.isOpen">
                        <template v-if="item.status == 0">
                            <li class="son_li" v-for="el in item.children">
                                <div class="txt son_li_skip"  :class="{white:item.title=='联系我们'}"  @click="tiaozhuan(el)"   >{{ el.title }}</div>
                            </li>
                        </template>
                        <template v-if="item.status == 1">
                            <li class="son_li contract_li" v-if="item.title == '联系地址'">
                                <div class="contract">
                                    <div class="address">地址：{{ footerData.linkInfo.address }}</div>
                                    <div class="address">电话：{{ footerData.linkInfo.tel }}</div>
                                    <div class="address">邮箱：{{ footerData.linkInfo.email }}</div>
                                </div>
                            </li>
                        </template>
                    </ul>


                </li>
            </ul>
            <div class="version" v-html="footerData.copyright"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Footer",
    components: {},
    data() {
        return {
            footerData: null
        };
    },
    async created() {
        // 测试环境
        if (window.location.href.indexOf("localhost") >= 0) {
            var res = await this.$post("/test/getPage", { id: 10 });
            var footerData = res.data;
        } else {
            var footerData = orginalJsonData.footer;
        }
        for (var k in footerData.menus) {
            footerData.menus[k]["isOpen"] = false;
            footerData.menus[k]["status"] = 0;
            for (var k2 in footerData.menus[k].children) {
                footerData.menus[k].children[k2]["isOpen"] = false;
            }
        }
        footerData.menus.push({
            title: "联系地址",
            status: 1,
            isOpen: false
        });
        this.footerData = footerData;
    },
    mounted() {},
    methods: {
        openMenu(item, index) {
            for (var k in this.footerData.menus) {
                if (k == index) {
                    this.footerData.menus[k].isOpen = !this.footerData.menus[k]
                        .isOpen;
                } else {
                    this.footerData.menus[k].isOpen = false;
                }
            }
            console.log(item);
        },
        tiaozhuan(item) {
            if(item.url){ 
                window.location.href = item.url;
            }
        }
    }
};
</script>
<style scoped>
/*去除a标签下划线*/
a {
    text-decoration: none;
    color: #fff;
}

/*去除未被访问的a标签的下划线*/
a:link {
    text-decoration: none;
    color: #fff;
}

/*去除已经被访问过的a标签的下划线*/
a:visited {
    text-decoration: none;
    color: #fff;
}

/*去除鼠标悬停时的a标签的下划线*/
a:hover {
    text-decoration: none;
    color: #fff;
}

/*去除正在点击的a标签的下划线（鼠标按下，尚未松开）*/
a:active {
    text-decoration: none;
    color: #fff;
}

/*去除获得焦点的a标签的下划线（被鼠标点击过）*/
a:focus {
    text-decoration: none;
    color: #fff;
}

.footer {
    width: 100%;
    background-color: #292e32;
    text-align: center;
    display: block;
    position: relative;
    z-index: 60;
    /* margin-top: 0.8rem; */
}

.wap_footer {
    display: none;
}

.footer .footer-con {
    width: 16.6rem;
    margin: 0px auto;
    padding: 0.58rem 0 0.26rem;
}

.footer .footer-con .foot-menus {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;
    text-align: center;
    overflow: hidden;
    width: 100%;
}

.footer .footer-con .foot-menus .left-cont {
    width: 9.3rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: row;
}

.footer .footer-con .foot-menus .left-cont .li {
    width: 14%;
}

.footer .footer-con .foot-menus .left-cont .li .son_li_skip.white{
    color: rgba(255,255,255,0.6);
}

.footer .footer-con .foot-menus .left-cont .li:nth-child(3) {
    width: 16%;
}
.footer .footer-con .foot-menus .left-cont .li:nth-child(6) {
    width: 40%;
}

.footer .footer-con .foot-menus .right-cont {
    width: 7.1rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;
    text-align: left;
}

.footer .footer-con .foot-menus .right-cont .border-li {
    padding: 0 0.66rem 0 0.56rem;
    position: relative;
}

.footer .footer-con .foot-menus .right-cont .bd-header::after {
    content: "";
    display: block;
    width: 0.26rem;
    height: 0.02rem;
    background: #ffffff;
}

.footer .footer-con .foot-menus .right-cont .border-li::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0.24rem;
    width: 0.02rem;
    height: 0.86rem;
    background: #3c4144;
}

.footer .footer-con .foot-menus .right-cont .border-li::after {
    content: "";
    display: block;
    position: absolute;
    right: 0;
    top: 0.24rem;
    width: 0.02rem;
    height: 0.86rem;
    background: #3c4144;
}

.footer .footer-con .foot-menus .right-cont .qrcode {
    width: 1.94rem;
    padding-top: 0.26rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
}

.footer .footer-con .foot-menus .right-cont .qrcode .item {
    width: 0.97rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.footer .footer-con .foot-menus .right-cont .qrcode .item .img {
    width: 0.84rem;
    height: 0.84rem;
}

.footer .footer-con .foot-menus .right-cont .qrcode .item .text {
    font-size: 0.12rem;
    color: #5c5f61;
    line-height: 0.3rem;
    padding-top: 0.06rem;
    text-align: center;
    transform: scale(0.9);
}

.footer .footer-con .foot-menus .mheader {
    line-height: 0.4rem;
    font-size: 0.18rem;
    color: #fff;
    padding-bottom: 0.18rem;
}

.footer .footer-con .foot-menus .link {
    line-height: 0.36rem;
    font-size: 0.16rem;
    color: #636668;
    display: block;
    cursor: pointer;
    word-wrap: normal;
    word-break: keep-all;
    white-space: nowrap;
}

.footer .copyright {
    height: 0.48rem;
    border-top: 0.02rem solid #414649;
    line-height: 0.48rem;
    color: #9d9d9d;
    font-size: 0.14rem;
}

.footer .copyright .space {
    margin: 0 0.08rem;
}

@media screen and (max-width: 768px) {
    .pc_footer {
        display: none;
    }

    .wap_footer {
        display: block;
    }

    .wap_footer {
        width: 100%;
        background-color: #282e31;
        color: #fff;
    }

    .wap_footer .menu_ul {
        padding-top: 0.15rem;
        width: 90%;
        margin: 0 auto;
    }

    .wap_footer .menu_li {
        width: 100%;
    }

    .wap_footer .menu_li .menu_li_span {
        width: 100%;
        display: flex;
        border-bottom: 0.02rem solid #fff;
        justify-content: space-between;
        align-items: center;
        height: 0.8rem;
    }

    .wap_footer .menu_li .menu_li_span .txt {
        font-size: 0.2rem;
    }

    .wap_footer .menu_li .menu_li_span .icon_open {
        height: 0.02rem;
        width: 0.23rem;
        background: url(../assets/common/menu_colse.png) no-repeat;
        background-size: 100% 100%;
        margin-right: 0.25rem;
    }

    .wap_footer .menu_li .menu_li_span .icon_close {
        height: 0.23rem;
        width: 0.23rem;
        background: url(../assets/common/menu_open.png) no-repeat;
        background-size: 100% 100%;
        margin-right: 0.25rem;
    }

    .wap_footer .menu_li .son {
    }

    .wap_footer .menu_li .son .son_li {
        text-align: left;
        border-bottom: 0.02rem solid #fff;
        height: 0.8rem;
        line-height: 0.8rem;
        padding-left: 0.25rem;
    }

    .wap_footer .menu_li .son .son_li .txt {
        font-size: 0.18rem;
        color: rgba(255, 255, 255, 0.3);
        width: 100%;
        display: block;
    }
    .wap_footer .menu_li .son .son_li .txt.white {
        color: rgba(255,255,255,0.6);
    }

    .wap_footer .version {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.2rem;
        color: #9d9d9d;
        padding-top: 0.65rem;
        padding-bottom: 0.45rem;
    }

    .wap_footer .menu_li .son .contract_li {
        padding: 0.4rem 0rem;
        height: auto;
        color: rgba(255, 255, 255, 0.3);
        font-size: 0.22rem;
        display: flex;
        justify-content: center;
        line-height: 0.4rem;
    }
    
    .wap_footer .menu_li .son .focus_li {
        padding: 0.4rem 0rem;
        height: auto;
        display: flex;
        justify-content: center;
    }

    .wap_footer .menu_li .son .focus {
        padding: 0.45rem 0rem;
        width: 4rem;
        height: 2.27rem;
        color: rgba(255, 255, 255, 0.3);
        font-size: 0.22rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.75rem;
        padding-bottom: 0.15rem;
    }

    .wap_footer .menu_li .son .focus .box {
        width: 1.77rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .wap_footer .menu_li .son .focus .box img {
        width: 1.73rem;
        height: 1.73rem;
    }
}
</style>
